/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PeripheralBody = {
    /**
     * Unique serial number of peripheral.
     */
    serial: string;
    /**
     * Type of peripheral.
     */
    type: PeripheralBody.type;
    /**
     * Model of the peripheral.
     */
    model: string;
    /**
     * Name of the peripheral.
     */
    name?: string;
    /**
     * Firmware version of the peripheral.
     */
    firmwareVersion: string;
    /**
     * TODO: What exactly is this the version of?
     */
    version: string;
};
export namespace PeripheralBody {
    /**
     * Type of peripheral.
     */
    export enum type {
        SCANNER = 'SCANNER',
        INVALID_DEVICE = 'INVALID_DEVICE',
    }
}

